'use es6';

import { Component } from 'react';
const FIELD_NAME = 'Form';
const ERROR_BOUNDARY_NAME = 'FormErrorBoundary';
const logError = error => {
  if (window.newrelic && window.newrelic.noticeError) {
    window.newrelic.noticeError(error, {
      fieldName: FIELD_NAME,
      errorBoundary: ERROR_BOUNDARY_NAME
    });
  }
};
class FormErrorBoundary extends Component {
  static getDerivedStateFromError(error) {
    logError(error);
    return {
      hasError: true
    };
  }
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  render() {
    return this.props.children;
  }
}
export default FormErrorBoundary;